import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppletContainerModel } from '../../../../../models/aggregates/applet/applet-container.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

// https://api.akaun.cloud/core2/tnt/dm/applets/login-tenant-ep/

@Injectable({
  providedIn: 'root'
})
export class AppletLoginTenantEpService extends BaseApiTemplateService<AppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applets/login-tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applets/login-tenant-ep';
    this.httpClient = http;
  }
}